import { useMediaQuery } from '@/shared/lib/useMediaQuery';
import { mobile } from '@/shared/ui/theme';
import { MobileWindowBackButton } from '@/shared/ui/templates';
import { useBugReportViewStore } from '../../model/bugReportViewStore';

/**
 * 제보 · 요청 창의 모바일 제목줄 앞자리 — 상세에서 목록으로 돌아가는 ‹.
 *
 * 카드 안에 있던 「← 목록으로」 버튼은 채움 · 테두리 · 14px 로 화면 전환 탭보다 강하게
 * 그려져 위계가 뒤집혀 있었다. 모양은 `MobileWindowBackButton` 이 정한다.
 */
export function BugReportMobileBack() {
  const isMobile = useMediaQuery(mobile);
  const open = useBugReportViewStore((st) => st.mobileDetailOpen);
  const close = useBugReportViewStore((st) => st.closeMobileDetail);

  if (!isMobile || !open) return null;

  return <MobileWindowBackButton onClick={close} />;
}
